module.exports = __webpack_public_path__ + "static/img/239_TO8_2166.34cd0d8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/239_TO8_2166.jpg
// module id = z1wN
// module chunks = 0